
import { defineComponent, reactive } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheTextarea from '@/common/components/UI/TheTextarea/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

// validations
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default defineComponent({
    components: {
        modal: Modal,
        'the-textarea': TheTextarea,
        'the-select': TheSelect,
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['cancel', 'submitted'],
    setup(props, { emit }) {
        const state = reactive({
            is_loading: false,
            rejection_comment: null as string | null,
            rejection_reason_id: null as number | null,
        })

        const REJECTION_REASONS = [
            {
                id: 1,
                name: 'Высокая ставка',
            },
            {
                id: 2,
                name: 'Долгие сроки',
            },
            {
                id: 3,
                name: 'Предварительный запрос',
            },
            {
                id: 4,
                name: 'Долгий просчет',
            },
        ]

        const state_form$ = useVuelidate(
            { rejection_comment: { required }, rejection_reason_id: { required } },
            state
        )

        const emitCancel = () => {
            emit('cancel')
        }

        const emitSubmitted = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('submitted', {
                rejection_comment: state.rejection_comment,
                rejection_reason_id: state.rejection_reason_id,
            })
        }

        return {
            state,
            state_form$,
            emitCancel,
            emitSubmitted,
            REJECTION_REASONS,
        }
    },
})
